import { createPageLoadMetric, INACCESSIBLE_PAGE_LOAD_KEY } from '@confluence/browser-metrics';

export const INACCESSIBLE_PAGE_LOAD = createPageLoadMetric({
	key: INACCESSIBLE_PAGE_LOAD_KEY,
});
